export enum EEX_PATHS {
  HOME = "https://sundaeswap.finance/",
  FAQ = "https://help.sundaeswap.finance/en/",
  YOUTUBE = "https://www.youtube.com/@sundaeswaplabs",
  LEARN_MORE_WALLETS = "https://docs.cardano.org/new-to-cardano/types-of-wallets",
  TWITTER = "https://twitter.com/SundaeSwap",
}
